import firebase from 'firebase/compat/app'
import 'firebase/compat/database'
import 'firebase/compat/firestore'
import 'firebase/compat/auth'

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBI478FL_iym7xf6sShOMz5NuQ2ScHAloA",
    authDomain: "convention-ferrarelle-2025.firebaseapp.com",
    projectId: "convention-ferrarelle-2025",
    storageBucket: "convention-ferrarelle-2025.firebasestorage.app",
    messagingSenderId: "813821375146",
    appId: "1:813821375146:web:624ce916a66683703316d3"
};


// Initialize Firebase
firebase.initializeApp(firebaseConfig)
const auth = firebase.auth()

const firestore = firebase.firestore()

export {firestore, firebase, auth}
